import { Immutable } from "immer";
import React from "react";

import { EditorContent } from "@thelabnyc/thelabui/src/components/EditorContent";

const WRAP_START = '<div class="raw-html-block">';
const WRAP_END = "</div>";

export const RawHTMLBlock = (
    props: Immutable<{
        value: string;
        className?: string;
        // For hosts whose raw markup is mutated by third-party code before
        // hydration (e.g. OneTrust footer buttons).
        suppressHydrationWarning?: boolean;
    }>,
): React.JSX.Element => {
    // Value is pre-wrapped in <div class="raw-html-block"> by RawHTML.__new__.
    // Strip that wrapper and apply the class directly so we don't nest an extra div.
    const inner =
        props.value.startsWith(WRAP_START) && props.value.endsWith(WRAP_END)
            ? props.value.slice(WRAP_START.length, -WRAP_END.length)
            : props.value;
    return (
        <EditorContent>
            {(marker) => (
                <div
                    className={["raw-html-block", props.className]
                        .filter(Boolean)
                        .join(" ")}
                    suppressHydrationWarning={props.suppressHydrationWarning}
                    dangerouslySetInnerHTML={{ __html: inner }}
                    {...marker}
                />
            )}
        </EditorContent>
    );
};
